module.exports = __webpack_public_path__ + "img/dec2.9125e818.jpg";